import { motion } from "framer-motion";

const IMGS = [
  { url: "https://images.pexels.com/photos/28262295/pexels-photo-28262295.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940", tag: "Night Rides" },
  { url: "https://images.unsplash.com/photo-1769673459559-be2da9592bc6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwzfHxzcG9ydHMlMjBtb3RvcmN5Y2xlJTIwbmlnaHQlMjBzdHJlZXR8ZW58MHx8fHwxNzc5NTI3NTgwfDA&ixlib=rb-4.1.0&q=85", tag: "Track Days" },
  { url: "https://images.pexels.com/photos/19079627/pexels-photo-19079627.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940", tag: "Cafe Racer Culture" },
  { url: "https://images.pexels.com/photos/17845189/pexels-photo-17845189.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940", tag: "Urban Riding" },
];

export default function RiderCulture() {
  return (
    <section id="culture" data-testid="rider-culture-section" className="relative py-24 md:py-36 overflow-hidden">
      <div className="absolute inset-0 metallic-bg" />

      <div className="relative max-w-[1400px] mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="max-w-3xl"
        >
          <span className="text-xs font-mono tracking-[0.3em] uppercase text-[#00cccc]">// Rider Culture</span>
          <h2 className="mt-4 text-4xl sm:text-5xl lg:text-6xl font-black leading-tight tracking-tight">
            More than a marketplace. <br />
            <span className="text-gradient-cyan">A rider ecosystem.</span>
          </h2>
          <p className="mt-5 text-zinc-400 text-lg max-w-xl">
            Biker Boulevard is building India's most premium motorcycle rider ecosystem — touring crews, cafe racer meets, night rides, and community-first experiences.
          </p>
        </motion.div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-12 gap-4">
          {IMGS.map((img, i) => (
            <motion.div
              key={img.url}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: i * 0.1 }}
              className={`group relative overflow-hidden rounded-2xl border border-white/5 ${
                i === 0 ? "md:col-span-7 md:row-span-2 h-[280px] md:h-[560px]" : "md:col-span-5 h-[270px]"
              }`}
              data-testid={`culture-card-${i + 1}`}
            >
              <img
                src={img.url}
                alt={img.tag}
                className="absolute inset-0 w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-[#050505]/30 to-transparent" />
              <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500" style={{ background: "linear-gradient(180deg, transparent 40%, rgba(0,204,204,0.15) 100%)" }} />
              <div className="absolute bottom-5 left-5 right-5 flex items-center justify-between">
                <span className="text-[10px] font-mono uppercase tracking-[0.25em] text-zinc-300 px-2.5 py-1 rounded-full border border-white/10 bg-black/40 backdrop-blur-md">
                  {img.tag}
                </span>
                <span className="w-2 h-2 rounded-full bg-[#00cccc] animate-pulse-glow" />
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
